import React from 'react'
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';

import PublicNav from "../components/PublicNav";
import Footer from "../components/Footer";

class Privacy extends React.Component {
  render () {
    return(
      <div>
      <MetaTags>
        <title>Privacy Policy - Agro Accounting CPA </title>
        <meta name="description" content="Agro Accounting CPA by Basil Agrocostea CPA is the one-stop destination for freelancers, artists and creative small businesses, for accounting service & help with tax preparation." />
      </MetaTags>
      <PublicNav />

      <div className="home-secondary-header-div">
        <p className="home-secondary-header">Privacy Policy</p>
        <div class="underline-thick"></div>
      </div>

      <div className="center-content">
          <br></br>

          <p className="terms-text">
          Thank you for choosing to be part of our community at Agro Accounting CPA P.C. (“Company”, “we”, “us”, or “our”). We are committed to protecting your personal information and your right to privacy. If you have any questions or concerns about our policy, or our practices with regards to your personal information, please contact us at basil@agroaccounting.com.
          <br></br>
          <br></br>
          When you visit our website https://agroaccounting.com/, and use our services, you trust us with your personal information. We take your privacy very seriously. In this privacy policy, we seek to explain to you in the clearest way possible what information we collect, how we use it and what rights you have in relation to it. We hope you take some time to read through it carefully, as it is important. If there are any terms in this privacy policy that you do not agree with, please discontinue use of our Sites and our services.
          <br></br>
          <br></br>
          This privacy policy applies to all information collected through our website (such as https://agroaccounting.com/), and/or any related services, sales, marketing or events (we refer to them collectively in this privacy policy as the "Services").
          <br></br>
          <br></br>
          Please read this privacy policy carefully as it will help you make informed decisions about sharing your personal information with us.
          </p>

          <br></br>

          <h1 className="terms-heading"> 1. WHAT INFORMATION DO WE COLLECT? </h1>

          <p className="terms-text">
          Personal information you disclose to us.
          <br></br>
          <br></br>
          In Short:  We collect personal information that you provide to us.
          <br></br>
          <br></br>
          We collect personal information that you voluntarily provide to us when registering at the Services expressing an interest in obtaining information about us or our products and services, when participating in activities on the Services or otherwise contacting us.
          <br></br>
          <br></br>
          The personal information that we collect depends on the context of your interactions with us and the Services, the choices you make and the products and features you use. The personal information we collect can include the following:
          <br></br>
          <br></br>
          Publicly Available Personal Information. We collect first name, maiden name, last name, and nickname; driver's license number; current and former address; phone numbers; email addresses; business email; business phone number; real estate records including purchase and sale prices and neighbour info; business entity filings, corporate affiliations, and business associates; government licenses, professional licenses, hunting/fishing permits, and weapons permits; and other similar data.
          <br></br>
          <br></br>
          Personal Information Provided by You. We collect past and current partners; taxation, pension, and maternity leave; financial information (credit card number, purchase history, invoices); and other similar data.
          <br></br>
          <br></br>
          Payment Data. We collect data necessary to process your payment if you make purchases, such as your payment instrument number (such as a credit card number), and the security code associated with your payment instrument. All payment data is stored by Stripe. You may find their privacy policy link(s) here: https://stripe.com/privacy.
          <br></br>
          <br></br>
          All personal information that you provide to us must be true, complete and accurate, and you must notify us of any changes to such personal information.
          </p>

          <br></br>
          <h1 className="terms-heading"> 2. HOW DO WE USE YOUR INFORMATION? </h1>

          <p className="terms-text">
          In Short:  We process your information for purposes based on legitimate business interests, the fulfillment of our contract with you, compliance with our legal obligations, and/or your consent.
          <br></br>
          <br></br>
          We use personal information collected via our Services for a variety of business purposes described below. We process your personal information for these purposes in reliance on our legitimate business interests, in order to enter into or perform a contract with you, with your consent, and/or for compliance with our legal obligations. We indicate the specific processing grounds we rely on next to each purpose listed below.
          <br></br>
          <br></br>
          We use the information we collect or receive:

          <ul>
            <li>■  To facilitate account creation and logon process. If you choose to link your account with us to a third party account (such as your Google or Facebook account), we use the information you allowed us to collect from those third parties to facilitate account creation and logon process for the performance of the contract.</li>
            <br></br>
            <li>■  Fulfill and manage your orders. We may use your information to fulfill and manage your orders, payments, returns, and exchanges made through the Services.</li>
            <br></br>
            <li>■  To manage user accounts. We may use your information for the purposes of managing our account and keeping it in working order.</li>
            <br></br>
            <li>■  To deliver services to the user. We may use your information to provide you with the requested service.</li>
            <br></br>
            <li>■  To respond to user inquiries/offer support to users. We may use your information to respond to your inquiries and solve any potential issues you might have with the use of our Services.</li>
          </ul>

          </p>

          <h1 className="terms-heading"> 3. WILL YOUR INFORMATION BE SHARED WITH ANYONE? </h1>

          <p className="terms-text">
          In Short:  We only share information with your consent, to comply with laws, to provide you with services, to protect your rights, or to fulfill business obligations.
          We may process or share data based on the following legal basis:
          <br></br>
          <br></br>
          ■  Consent: We may process your data if you have given us specific consent to use your personal information for a specific purpose.
          <br></br>
          <br></br>
          ■  Legitimate Interests: We may process your data when it is reasonably necessary to achieve our legitimate business interests.
          <br></br>
          <br></br>
          ■  Performance of a Contract: Where we have entered into a contract with you, we may process your personal information to fulfill the terms of our contract.
          <br></br>
          <br></br>
          ■  Legal Obligations: We may disclose your information where we are legally required to do so in order to comply with applicable law, governmental requests, a judicial proceeding, court order, or legal process, such as in response to a court order or a subpoena (including in response to public authorities to meet national security or law enforcement requirements).
          <br></br>
          <br></br>
          ■  Vital Interests: We may disclose your information where we believe it is necessary to investigate, prevent, or take action regarding potential violations of our policies, suspected fraud, situations involving potential threats to the safety of any person and illegal activities, or as evidence in litigation in which we are involved.

          <br></br>
          <br></br>
          More specifically, we may need to process your data or share your personal information in the following situations:
          <br></br>
          <br></br>
          ■  Vendors, Consultants and Other Third-Party Service Providers. We may share your data with third party vendors, service providers, contractors or agents who perform services for us or on our behalf and require access to such information to do that work. Examples include: payment processing, data analysis, email delivery, hosting services, customer service and marketing efforts. We may allow selected third parties to use tracking technology on the Services, which will enable them to collect data about how you interact with the Services over time. This information may be used to, among other things, analyze and track data, determine the popularity of certain content and better understand online activity. Unless described in this Policy, we do not share, sell, rent or trade any of your information with third parties for their promotional purposes.
          <br></br>
          <br></br>
          ■  Business Transfers. We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.
          <br></br>
          <br></br>
          ■  Third-Party Advertisers. We may use third-party advertising companies to serve ads when you visit the Services. These companies may use information about your visits to our Website(s) and other websites that are contained in web cookies and other tracking technologies in order to provide advertisements about goods and services of interest to you.
          </p>

          <h1 className="terms-heading"> 4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES? </h1>
          <p className="terms-text">

          In Short:  We may use cookies and other tracking technologies to collect and store your information.
          <br></br>
          <br></br>
          We may use cookies and similar tracking technologies (like web beacons and pixels) to access or store information. Specific information about how we use such technologies and how you can refuse certain cookies is set out in our Cookie Policy.

          </p>


          <h1 className="terms-heading"> 5. HOW LONG DO WE KEEP YOUR INFORMATION? </h1>
          <p className="terms-text">

          In Short:  We keep your information for as long as necessary to fulfill the purposes outlined in this privacy policy unless otherwise required by law.
          <br></br>
          <br></br>
          We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy policy, unless a longer retention period is required or permitted by law (such as tax, accounting or other legal requirements). No purpose in this policy will require us keeping your personal information for longer than the period of time in which users have an account with us.
          <br></br>
          <br></br>
          When we have no ongoing legitimate business need to process your personal information, we will either delete or anonymize it, or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely store your personal information and isolate it from any further processing until deletion is possible.
          </p>




          <h1 className="terms-heading"> 6. HOW DO WE KEEP YOUR INFORMATION SAFE? </h1>
          <p className="terms-text">

          In Short:  We aim to protect your personal information through a system of organizational and technical security measures.
          <br></br>
          <br></br>
          We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, please also remember that we cannot guarantee that the internet itself is 100% secure. Although we will do our best to protect your personal information, transmission of personal information to and from our Services is at your own risk. You should only access the services within a secure environment.
          </p>




          <h1 className="terms-heading"> 7. DO WE COLLECT INFORMATION FROM MINORS? </h1>
          <p className="terms-text">
          In Short:  We do not knowingly collect data from or market to children under 18 years of age.
          <br></br>
          <br></br>
          We do not knowingly solicit data from or market to children under 18 years of age. By using the Services, you represent that you are at least 18 or that you are the parent or guardian of such a minor and consent to such minor dependent’s use of the Services. If we learn that personal information from users less than 18 years of age has been collected, we will deactivate the account and take reasonable measures to promptly delete such data from our records. If you become aware of any data we have collected from children under age 18, please contact us at basil@agroaccounting.com.
          </p>

          <h1 className="terms-heading"> 8. WHAT ARE YOUR PRIVACY RIGHTS? </h1>
          <p className="terms-text">
          In Short:  You may review, change, or terminate your account at any time.
          <br></br>
          <br></br>
          If you are a resident in the European Economic Area and you believe we are unlawfully processing your personal information, you also have the right to complain to your local data protection supervisory authority. You can find their contact details here: http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm.
          <br></br>
          <br></br>
          If you have questions or comments about your privacy rights, you may email us at basil@agroaccounting.com.
          <br></br>
          <br></br>
          Account Information
          If you would at any time like to review or change the information in your account or terminate your account, you can:
          <br></br>
          <br></br>
          ■  Log into your account settings and update your user account.
          <br></br>
          ■  Contact us using the contact information provided.
          <br></br>
          <br></br>
          Upon your request to terminate your account, we will deactivate or delete your account and information from our active databases. However, some information may be retained in our files to prevent fraud, troubleshoot problems, assist with any investigations, enforce our Terms of Use and/or comply with legal requirements.
          <br></br>
          <br></br>
          Cookies and similar technologies: Most Web browsers are set to accept cookies by default. If you prefer, you can usually choose to set your browser to remove cookies and to reject cookies. If you choose to remove cookies or reject cookies, this could affect certain features or services of our Services. To opt-out of interest-based advertising by advertisers on our Services visit http://www.aboutads.info/choices/.
          <br></br>
          <br></br>
          Opting out of email marketing: You can unsubscribe from our marketing email list at any time by clicking on the unsubscribe link in the emails that we send or by contacting us using the details provided below. You will then be removed from the marketing email list – however, we will still need to send you service-related emails that are necessary for the administration and use of your account. To otherwise opt-out, you may:
          <br></br>
          <br></br>
          ■  Contact us using the contact information provided.
          </p>

          <h1 className="terms-heading"> 9. CONTROLS FOR DO-NOT-TRACK FEATURES </h1>
          <p className="terms-text">
          Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track (“DNT”) feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. No uniform technology standard for recognizing and implementing DNT signals has been finalized. As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this privacy policy.
          </p>

          <h1 className="terms-heading"> 10. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS? </h1>
          <p className="terms-text">
          In Short:  Yes, if you are a resident of California, you are granted specific rights regarding access to your personal information.
          <br></br>
          <br></br>
          California Civil Code Section 1798.83, also known as the “Shine The Light” law, permits our users who are California residents to request and obtain from us, once a year and free of charge, information about categories of personal information (if any) we disclosed to third parties for direct marketing purposes and the names and addresses of all third parties with which we shared personal information in the immediately preceding calendar year. If you are a California resident and would like to make such a request, please submit your request in writing to us using the contact information provided below.
          <br></br>
          <br></br>
          If you are under 18 years of age, reside in California, and have a registered account with the Services, you have the right to request removal of unwanted data that you publicly post on the Services. To request removal of such data, please contact us using the contact information provided below, and include the email address associated with your account and a statement that you reside in California. We will make sure the data is not publicly displayed on the Services, but please be aware that the data may not be completely or comprehensively removed from our systems.
          </p>

          <h1 className="terms-heading"> 11. DO WE MAKE UPDATES TO THIS POLICY? </h1>
          <p className="terms-text">
          In Short:  Yes, we will update this policy as necessary to stay compliant with relevant laws.
          <br></br>
          <br></br>
          We may update this privacy policy from time to time. The updated version will be indicated by an updated “Revised” date and the updated version will be effective as soon as it is accessible. If we make material changes to this privacy policy, we may notify you either by prominently posting a notice of such changes or by directly sending you a notification. We encourage you to review this privacy policy frequently to be informed of how we are protecting your information.
          </p>

          <h1 className="terms-heading"> 12. HOW CAN YOU CONTACT US ABOUT THIS POLICY? </h1>
          <p className="terms-text">
          If you have questions or comments about this policy, you may email us at basil@agroaccounting.com or by post to:

          <b>
          <br></br>
          Agro Accounting CPA P.C.
          <br></br>
          Headquarters
          <br></br>
          42 West Street
          <br></br>
          Brooklyn, NY 11222
          <br></br>
          United States
          </b>
          </p>

          <h1 className="terms-heading"> 13. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</h1>
          <p className="terms-text">
        Based on the laws of some countries, you may have the right to request access to the personal information we collect from you, change that information, or delete it in some circumstances. To request to review, update, or delete your personal information, please visit: https://www.agroaccounting.com/Contact. We will respond to your request within 30 days.
          </p>


          <br></br>
          <br></br>

          <Footer />

















      </div>


      </div>
    );

  }
}

export default Privacy;
